
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_qk1j1_10qdd_94",
  "textarea": "awsui_textarea_qk1j1_10qdd_98",
  "textarea-readonly": "awsui_textarea-readonly_qk1j1_10qdd_122",
  "textarea-invalid": "awsui_textarea-invalid_qk1j1_10qdd_158"
};
  